// extracted by mini-css-extract-plugin
module.exports = {"IconBase":"IconKrapLogo_IconBase__1AXG1","IconPrimary":"IconKrapLogo_IconPrimary__20y_P"};